import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { distinct, stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { IFileDownloader } from "src/uicomponents/components/fileSelector/fileSelector-viewModel";
import { FileSelectorViewModel } from "uicomponents";
import { IReport } from "../IReport";
import  { ReportEditorView } from "./reportEditor-view"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { typeSelector } from "src/formBuilder/components/clientFilterTable/columnsEditorViewModel/popupColumnsEditor/popupColumnsEditor-viewModel";

interface IPropertyList{
    removeProperty(property:singleReportProperty);
}

export class ReportEditorViewModel extends ViewModel implements IReport,IPopup,IPropertyList{ 
    constructor(parentViewModel: ViewModel,updater : IServerUpdater) {
        super(parentViewModel);

        this.isReportChanged = true;
        this.properties = ObservableArray.create<singleReportProperty>();
        
        this.fileSelector = new FileSelectorViewModel(this);
        this.fileSelector.downloader = new FileDownloader();
        this.fileSelector.onFileChoosed = content=>this.onFileChoosed(content);
        
        this._updater = updater;
    }
    removeProperty(property: singleReportProperty) {
        this.properties.remove(property);
    }
    GetDefaultView(): View <ViewModel> {
        return new ReportEditorView();
    }
    public getTypeId(): string {
        return "VM-C7E34AF9-9AD0-4A86-9917-CFD3C232E18A"
    }

    closePopup(result: any) {
    }
    async loadFromServer(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ReportServices/GetReportFileStructure',{
                Id : this.id
            });
            this.reportStructure = result.Structure;
            this.isReportStructureChanged = false;
            this.deserializeReportStructure();
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    private _updater:IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set id(v: string) { 
        this._id = v; 
        this.fileSelector.fileid = v;
    } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { 
        this._name = v; 
        if(this.fileSelector)
            this.fileSelector.filename = v;
    } public get name(): string { return this._name;} private _name: string;
    public set path(v: string) { this._path = v; } public get path(): string { return this._path;} private _path: string;
    public set isReportChanged(v: boolean) { this._isReportChanged = v; } public get isReportChanged(): boolean { return this._isReportChanged;} private _isReportChanged: boolean;
    public set content(v: string) { this._content = v; } public get content(): string { return this._content;} private _content: string;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public set reportStructure(v: string) { 
        this._reportStructure = v; 
        this.isReportStructureChanged = true;
    } public get reportStructure(): string { return this._reportStructure;} private _reportStructure: string;
    public set isReportStructureChanged(v: boolean) { this._isReportStructureChanged = v; } public get isReportStructureChanged(): boolean { return this._isReportStructureChanged;} private _isReportStructureChanged: boolean;
    public set properties(v: ObservableArray<singleReportProperty>) { this._properties = v; } public get properties(): ObservableArray<singleReportProperty> { return this._properties;} private _properties: ObservableArray<singleReportProperty>;
    
    addProperty(){
        let property = new singleReportProperty(this,true);
        this.properties.push(property);
    }
    back(){
        this.closePopup(null);
    }

    async save(){
        let verificationResult = this.verify();
        if(verificationResult.length>0){
            this.messageBoxConfirmWarning(verificationResult.join('\n'),'خطا در ثبت گزارش');
            return;
        }else{
            this.serializeReportStructure();
            try {
                this.isLoading = true;
                let result = await this._updater.execute(this);
                await this.messageBoxConfirmSuccess('گزارش با موفقیت ثبت شد.','ثبت موفق');
                this.closePopup(this);
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning('خطا در ثبت گزارش','خطا در عملیات');
            } finally {
                this.isLoading = false;
            }
        }
    }
    verify():string[]{
        let result :string[] = [];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.path)){
            result.push('مسیر مشخص نشده است.')
        }
        if(this.isReportChanged==true && stringIsNullOrEmpty(this.content)){
            result.push('فایل مشخص نشده است.')
        }
        result.push(...this.verifyProperties());
        return result;
    }
    verifyProperties() : string[]{
        let result : string[] = []
        this.properties.forEach(x=>result.push(...x.verify()));
        result = distinct(result);
        return result;
    }
    cloneTo(report:IReport){
        report.id = this.id;
        report.name = this.name;
        report.path = this.path;
        report.content = this.content;
        report.isReportChanged = this.isReportChanged;
    }

    onFileChoosed(content:string){
        this.isReportChanged = true;
        this.content = content;
    }

    async editReport(){
        let verificationResult = this.verifyProperties();
        if(verificationResult.length>0){
            await this.messageBoxConfirmWarning(verificationResult.join('\n'),'خطا');
            return;
        }
        this.serializeReportStructure();
        let reportContent = '';
        if(this.fileSelector.checkDownloadability){
            reportContent =await this.fileSelector.getContent()
        }
        let response = await fetch("http://localhost:64010",{
            method:"POST",
            body:JSON.stringify({
                Mode:"Design",
                Report:reportContent ?? "",
                ReportStructure:this.reportStructure
                // CopyCount : 2,
                // ReportData : {
                //     a:'a1',
                //     b:12,
                //     c:true,
                //     d:[{f:1,e:'e1'},{f:2,e:'e2'}]
                // }
            })
        });
        this.content = await response.text();
        this.isReportChanged = true;
        this.fileSelector.filecontent = this.content;
    }

    deserializeReportStructure(){
        if(stringIsNullOrEmpty(this.reportStructure)){

        }else{
            var o;
            eval("o =" + this.reportStructure);
            let validJson = JSON.stringify(o);
            let serilizedObj = JSON.parse(validJson);
            let keys = Object.keys(serilizedObj);
            this.properties.update(...keys.map(x=>{
                let child = new singleReportProperty(this,true);
                child.deserialize(x,serilizedObj[x]);
                return child;
            }))
        }
    }
    serializeReportStructure(){
        let resultObj : any ={};
        this.properties.forEach(x=>x.serialize(resultObj));
        this.reportStructure = JSON.stringify(resultObj);
    }
}

export interface IServerUpdater{
    execute(personnel:IReport):Promise<any>;
}

export class ReportInserter implements IServerUpdater{
    async execute(report: IReport): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ReportServices/CreateNewReport',{
                Name : report.name,
                Path : report.path,
                Content : report.content,
                ReportFileStructure : report.reportStructure
            });
            if(result.IsSuccessful==false){
                throw "Error Saving Report";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}


export class ReportUpdater implements IServerUpdater{
    async execute(report: IReport): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ReportServices/UpdateReportFile',{
                Id : report.id,
                Name:report.name,
                Path : report.path,
                IsReportFileUpdated : report.isReportChanged,
                Content : report.content,
                IsReportFileStructureChanged : report.isReportStructureChanged,
                ReportFileStructure : report.reportStructure
            });
            if(result.IsSuccessful==false){
                throw "Error Saving Report";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}

class FileDownloader implements IFileDownloader{
    async download(fileId: string, filename: string): Promise<{ name: string; content: string; }> {
        let result = await ServerConnection.callServer('/Complex/ReportServices/GetReportFile',{
            Id : fileId
        });
        return {
            name : filename,
            content : result.Content
        }
    }

}
export class singleReportProperty extends ViewModel implements IPropertyList{
    verify() :string[] {
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push('ویژگی با نام خالی امکان پذیر نیست.')
        }
        if(this.typeSelector.selectedItem==null){
            result.push('ویژگی بدون نوع وجود دارد.')
        }else{
            if(this.typeSelector.selectedItem.id=='list'){
                this.children.forEach(x=>result.push(...x.verify()));
            }

        }
        return result;
    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    sample(x){
        console.log(x);
        return x;
    }
    constructor(parent:ViewModel,containListType?:boolean) {
        super(parent);
        containListType = containListType ?? false;
        this.children = ObservableArray.create<singleReportProperty>();
        this.typeSelector = new ReportPropertyTypeSelector(this,containListType);
        this.typeSelector.onSelectionChanged = x=>{
            this.hasChildren = x.id=='list';
        };
        this.parentList = <IPropertyList><any>parent;
    }
    removeProperty(property: singleReportProperty) {
        this.children.remove(property);
    }
    private parentList : IPropertyList;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set typeSelector(v: ReportPropertyTypeSelector) { this._typeSelector = v; } public get typeSelector(): ReportPropertyTypeSelector { return this._typeSelector;} private _typeSelector: ReportPropertyTypeSelector;
    public set hasChildren(v: boolean) { this._hasChildren = v; } public get hasChildren(): boolean { return this._hasChildren;} private _hasChildren: boolean;
    public set children(v: ObservableArray<singleReportProperty>) { this._children = v; } public get children(): ObservableArray<singleReportProperty> { return this._children;} private _children: ObservableArray<singleReportProperty>;
    
    addChild(){
        let property = new singleReportProperty(this,false);
        this.children.push(property);
    }
    remove(){
        this.parentList.removeProperty(this);
    }

    serialize(resultObj:any): void {
        if(this.typeSelector.selectedItem.id=='list'){
            let innerResultObj = {};
            this.children.forEach(x=>x.serialize(innerResultObj));
            resultObj[this.name] = [innerResultObj];
        }else{
            resultObj[this.name] = this.typeSelector.selectedItem.id;
        }
    }
    deserialize(key:string,value:any){
        this.name = key;
        if(typeof value == 'string'){
            this.typeSelector.selectById(value);
        }else{
            let serilizedObj = value[0];
            this.typeSelector.selectById('list');
            let keys = Object.keys(serilizedObj);
            this.children.update(...keys.map(x=>{
                let child = new singleReportProperty(this,false);
                child.deserialize(x,serilizedObj[x]);
                return child;
            }))
        }
    }
}

export class ReportPropertyTypeSelector extends SelectorBaseViewModel<singlePropertyType>{

    private _containListType : boolean;
    constructor(parentViewModel:ViewModel,containListType:boolean) {
        super(parentViewModel,true);
        
        this._containListType = containListType;
        this.refresh();
    }
    protected loadData(): Promise<singlePropertyType[]> {
        let result = [
            new singlePropertyType(this,"string","string"),
            new singlePropertyType(this,"long","long"),
            new singlePropertyType(this,"int","int"),
            new singlePropertyType(this,"boolean","boolean"),
            new singlePropertyType(this,"float","float"),
            new singlePropertyType(this,"image","image")
        ];
        if(this._containListType){
            result.push(new singlePropertyType(this,"list","list"));
        }
        return Promise.resolve<singlePropertyType[]>(result);
    }
}

export class singlePropertyType extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,id:string,title:string) {
        super(parent);
        
        this.id = id;
        this.title = title;
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    
}